import { useQuery } from "@tanstack/react-query";

export const TRENDING_MARKETS_QUERY_KEY = ["markets", "trending"] as const;

export interface TrendingMarket {
  id: string;
  slug: string;
  title: string;
  image: string;
  volume24hr: number;
  oneDayPriceChange?: number;
  outcomePrices?: string;
  clobTokenIds?: string;
  markets?: {
    id: string;
    slug?: string;
    clobTokenIds?: string;
    outcomePrices?: string;
  }[];
}

export function useTrendingMarketsQuery() {
  return useQuery<TrendingMarket[]>({
    queryKey: TRENDING_MARKETS_QUERY_KEY,
    queryFn: async () => {
      const res = await fetch("/api/markets/trending");
      if (!res.ok) throw new Error(`${res.status}`);
      const data = await res.json();
      return data.markets || [];
    },
    staleTime: 5 * 60_000, // 5 min — sidebar data, no need to refetch on every navigation
    gcTime: 10 * 60_000,
  });
}
